// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-precaution-list{padding-left:1em;font-size:12px;line-height:1.7em;color:#979797;text-align:left}.h-precaution-list__item{text-indent:-1em;list-style:none}.h-precaution-list__item:not(:first-child){margin-top:.5em}.h-precaution-list--dense .h-precaution-list__item:not(:first-child){margin-top:0}", ""]);
// Exports
module.exports = exports;
